export class Success<T> {
	/**
	 * コンストラクタ
	 * @param value 値
	 */
	constructor(readonly value: T) {
		this.value = value;
	}

	/**
	 * Result が Success であるかどうかを返します。
	 * @returns Result が Success であるかどうか
	 */
	isSuccess(): this is Success<T> {
		return true;
	}

	/**
	 * Result が Failure であるかどうかを返します。
	 * @returns Result が Failure であるかどうか
	 */
	isFailure(): this is Failure<Error> {
		return false;
	}

	/**
	 * Result の型に対応した関数を実行します。
	 * @param param.onSuccess Success の場合に実行する関数
	 * @param param.onFailure Failure の場合に実行する関数
	 * @returns onSuccess または onFailure の返り値
	 */
	when<U, V>({
		onSuccess,
	}: {
		onSuccess: (value: T) => U;
		onFailure: (error: never) => V;
	}) {
		return onSuccess(this.value);
	}
}

export class Failure<E extends Error> {
	/**
	 * コンストラクタ
	 * @param error エラー
	 */
	constructor(readonly error: E) {
		this.error = error;
	}

	/**
	 * Result が Success であるかどうかを返します。
	 * @returns Result が Success であるかどうか
	 */
	isSuccess(): this is Success<unknown> {
		return false;
	}

	/**
	 * Result が Failure であるかどうかを返します。
	 * @returns Result が Failure であるかどうか
	 */
	isFailure(): this is Failure<E> {
		return true;
	}

	/**
	 * Result の型に対応した関数を実行します。
	 * @param param.onSuccess Success の場合に実行する関数
	 * @param param.onFailure Failure の場合に実行する関数
	 * @returns onSuccess または onFailure の返り値
	 */
	when<U, V>({
		onFailure,
	}: {
		onSuccess: (value: never) => U;
		onFailure: (error: E) => V;
	}) {
		return onFailure(this.error);
	}
}

export type Result<T, E extends Error> = Success<T> | Failure<E>;
